import February2018 from './assets/2018/february-2018.jpg';
import February22018 from './assets/2018/february-2-2018.jpg';
import March2018 from './assets/2018/march-2018.jpg';
import October2018 from './assets/2018/october-2018.jpg';

import april2019 from './assets/2019/april-2019.jpg';
import april22019 from './assets/2019/april-2-2019.jpg';

import february2020 from './assets/2020/february-2020.jpg';
import februaryVideo2020 from './assets/2020/video.mp4';

import september2021 from './assets/2021/september-2021.jpg';
import september22021 from './assets/2021/september-2-2021.jpg';
import september32021 from './assets/2021/september-3-2021.jpg';
import september42021 from './assets/2021/september-4-2021.jpg';
import september52021 from './assets/2021/september-5-2021.jpg';

import march2022 from './assets/2022/march-2022.jpg';
import march22022 from './assets/2022/march-2-2022.jpg';
import march32022 from './assets/2022/march-3-2022.jpg';
import march42022 from './assets/2022/march-4-2022.jpg';
import march52022 from './assets/2022/march-5-2022.jpg';
import march62022 from './assets/2022/march-6-2022.png';

import October2022 from './assets/2022/october-2022.jpg';
import October22022 from './assets/2022/october-2-2022.jpg';
import October32022 from './assets/2022/october-3-2022.jpg';
import October42022 from './assets/2022/october-4-2022.jpg';

import Iceland2023 from './assets/2023/Iceland/1.png';
import Iceland22023 from './assets/2023/Iceland/2.jpg';
import Iceland32023 from './assets/2023/Iceland/3.jpg';
import Iceland42023 from './assets/2023/Iceland/4.png';
import Iceland52023 from './assets/2023/Iceland/5.jpg';
import Iceland62023 from './assets/2023/Iceland/6.jpg';

import Castle2024 from './assets/2024/Castle/1.jpg';
import Castle22024 from './assets/2024/Castle/2.jpg';
import Castle32024 from './assets/2024/Castle/3.jpg';
import Castle42024 from './assets/2024/Castle/4.jpg';

import Vietnam2024 from './assets/2024/Vietnam/1.mp4';
import Vietnam22024 from './assets/2024/Vietnam/2.jpg';
import Vietnam32024 from './assets/2024/Vietnam/3.jpg';
import Vietnam42024 from './assets/2024/Vietnam/4.jpg';
import Vietnam52024 from './assets/2024/Vietnam/5.jpg';

export const SLIDES = [
  {
    id: 1,
    width: 537,
    year: 2018,
    transform: { rotate: -3.5 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content: February2018,
        month: 'February'
      },
      {
        id: 2,
        duration: 4000,
        content: February22018,
        month: 'February'
      },
      {
        id: 3,
        duration: 4000,
        content: March2018,
        month: 'March'
      },
      {
        id: 4,
        duration: 4000,
        content: October2018,
        month: 'October'
      }
    ],
    description:
      'We went through the W18 batch of the startup accelerator Y Combinator, launched Nomad Insurance, raised seed and grew our team from 3 founders to 7'
  },
  {
    id: 2,
    width: 637,
    year: 2019,
    transform: { rotate: -3.5 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content: april2019,
        month: 'April'
      },
      {
        id: 2,
        duration: 4000,
        content: april22019,
        month: 'April'
      }
    ],
    description:
      'We established the SafetyWing embassy and HQ in San Francisco, our home and house with a roof terrace in North Beach. SafetyWing birds still visit regularly.'
  },
  {
    id: 3,
    width: 255,
    year: 2020,
    transform: { rotate: 1.2 },
    stories: [
      {
        id: 1,
        duration: 11500,
        type: 'video',
        content: februaryVideo2020,
        month: 'February'
      },
      {
        id: 2,
        duration: 4000,
        content: february2020,
        month: 'February'
      }
    ],
    description:
      'We launched Remote Health - the world’s first global health insurance tailored for remote teams, with the pandemic hitting full force and the whole world working remotely just a few days later'
  },
  {
    id: 4,
    width: 647,
    year: 2021,
    transform: { rotate: 1.7 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content: september2021,
        month: 'September'
      },
      {
        id: 2,
        duration: 4000,
        content: september22021,
        month: 'September'
      },
      {
        id: 3,
        duration: 4000,
        content: september32021,
        month: 'September'
      },
      {
        id: 4,
        duration: 4000,
        content: september42021,
        month: 'September'
      },
      {
        id: 5,
        duration: 4000,
        content: september52021,
        month: 'September'
      }
    ],
    description:
      'After quarantining and no traveling for almost 2 years, we were finally able to meet up again in person - this time in Slovenia'
  },
  {
    id: 5,
    width: 645,
    year: 2022,
    transform: { rotate: 2 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content: march2022,
        month: 'March'
      },
      {
        id: 2,
        duration: 4000,
        content: march22022,
        month: 'March'
      },
      {
        id: 3,
        duration: 4000,
        content: march32022,
        month: 'March'
      },
      {
        id: 4,
        duration: 4000,
        content: march42022,
        month: 'March'
      },
      {
        id: 5,
        duration: 4000,
        content: march52022,
        month: 'March'
      },
      {
        id: 6,
        duration: 4000,
        content: march62022,
        month: 'March'
      }
    ],
    description:
      'We gathered in Tulum-Mexico, with our now much bigger team serving more happy customers ' +
      'than ever, and gearing up for launches that will take us to a full global social safety net'
  },
  {
    id: 6,
    width: 645,
    year: 2022,
    transform: { rotate: 2 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content: October2022,
        month: 'October'
      },
      {
        id: 2,
        duration: 4000,
        content: October22022,
        month: 'October'
      },
      {
        id: 3,
        duration: 4000,
        content: October32022,
        month: 'October'
      },
      {
        id: 4,
        duration: 4000,
        content: October42022,
        month: 'October'
      }
    ],
    description:
      'We gathered in Bali-Indonesia, with our now much bigger team serving more happy customers than ever, and gearing up for launches that will take us to a full global social safety net'
  },
  {
    id: 7,
    width: 575,
    year: 2023,
    transform: { rotate: -2.2 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content: Iceland2023,
        month: 'December'
      },
      {
        id: 2,
        duration: 4000,
        content: Iceland22023,
        month: 'December'
      },
      {
        id: 3,
        duration: 4000,
        content: Iceland32023,
        month: 'December'
      },
      {
        id: 4,
        duration: 4000,
        content: Iceland42023,
        month: 'December'
      },
      {
        id: 5,
        duration: 4000,
        content: Iceland52023,
        month: 'December'
      },
      {
        id: 6,
        duration: 4000,
        content: Iceland62023,
        month: 'December'
      }
    ],
    description:
      'In a remote location in Iceland, we got warm and cozy under the Northern' +
      ' Lights to celebrate 2023 and get inspired for 2024.'
  },
  {
    id: 8,
    width: 600,
    year: 2024,
    transform: { rotate: 2 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content: Castle2024,
        month: 'June'
      },
      {
        id: 2,
        duration: 4000,
        content: Castle22024,
        month: 'June'
      },
      {
        id: 3,
        duration: 4000,
        content: Castle32024,
        month: 'June'
      },
      {
        id: 4,
        duration: 4000,
        content: Castle42024,
        month: 'June'
      }
    ],
    description:
      'We stayed in a medieval German castle for our first Build Week in real life' +
      ', to make fast progress on important things.'
  },
  {
    id: 9,
    width: 700,
    year: 2024,
    transform: { rotate: 3 },
    stories: [
      {
        id: 1,
        duration: 5000,
        type: 'video',
        content: Vietnam2024,
        month: 'November'
      },
      {
        id: 2,
        duration: 4000,
        content: Vietnam22024,
        month: 'November'
      },
      {
        id: 3,
        duration: 4000,
        content: Vietnam32024,
        month: 'November'
      },
      {
        id: 4,
        duration: 4000,
        content: Vietnam42024,
        month: 'November'
      },
      {
        id: 5,
        duration: 4000,
        content: Vietnam52024,
        month: 'November'
      }
    ],
    description:
      'We gathered in Hoi An, Vietnam, to celebrate the Year of Quality and steep' +
      ' ourselves in the culture of gifts, gratitude, and optimism.'
  }
];

export const SLIDES_MOBILE = [
  {
    id: 1,
    width: 300,
    year: 2018,
    isColumn: true,
    transform: { rotate: -3.5 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content1: February2018,
        content2: February22018,
        month: 'February'
      },
      {
        id: 2,
        duration: 4000,
        content1: March2018,
        content2: October2018,
        month: 'March and October'
      }
    ],
    description:
      'We went through the W18 batch of the startup accelerator Y Combinator, launched Nomad Insurance, ' +
      'raised seed and grew our team from 3 founders to 7'
  },
  {
    id: 2,
    width: 300,
    year: 2019,
    isColumn: true,
    transform: { rotate: -3.5 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content1: april2019,
        content2: april22019,
        month: 'April'
      }
    ],
    description:
      'We established the SafetyWing embassy and HQ in San Francisco, our home and house with a roof ' +
      'terrace in North Beach. SafetyWing birds still visit regularly.'
  },
  {
    id: 3,
    width: 255,
    year: 2020,
    isColumn: false,
    transform: { rotate: 1.2 },
    stories: [
      {
        id: 1,
        duration: 11500,
        type: 'video',
        content: februaryVideo2020,
        month: 'February'
      },
      {
        id: 2,
        duration: 4000,
        content: february2020,
        month: 'March'
      }
    ],
    description:
      'We launched Remote Health - the world’s first global health insurance tailored for remote teams, ' +
      'with the pandemic hitting full force and the whole world working remotely just a few days later'
  },
  {
    id: 4,
    width: 300,
    year: 2021,
    isColumn: true,
    transform: { rotate: -2.5 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content1: september2021,
        content2: september22021,
        month: 'September'
      },
      {
        id: 2,
        duration: 4000,
        content1: september32021,
        content2: september52021,
        month: 'September'
      }
    ],
    description:
      'After quarantining and no traveling for almost 2 years, we were finally able to meet up ' +
      'again in person - this time in Slovenia'
  },
  {
    id: 5,
    width: 300,
    year: 2022,
    isColumn: true,
    transform: { rotate: 2 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content1: march2022,
        content2: march22022,
        month: 'March'
      },

      {
        id: 2,
        duration: 4000,
        content1: march32022,
        content2: march42022,
        month: 'March'
      },
      {
        id: 3,
        duration: 4000,
        content1: march52022,
        content2: march62022,
        month: 'March'
      }
    ],
    description:
      'We gathered in Tulum-Mexico, with our now much bigger team serving more happy customers ' +
      'than ever, and gearing up for launches that will take us to a full global social safety net'
  },
  {
    id: 6,
    width: 300,
    year: 2022,
    isColumn: true,
    transform: { rotate: 2 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content1: October2022,
        content2: October22022,
        month: 'October'
      },
      {
        id: 2,
        duration: 4000,
        content1: October32022,
        content2: October42022,
        month: 'October'
      }
    ],
    description:
      'We gathered in Bali-Indonesia, with our now much bigger team serving more happy customers than ' +
      'ever, and gearing up for launches that will take us to a full global social safety net'
  },
  {
    id: 7,
    width: 300,
    year: 2023,
    isColumn: true,
    transform: { rotate: -2.2 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content1: Iceland2023,
        content2: Iceland22023,
        month: 'December'
      },
      {
        id: 2,
        duration: 4000,
        content1: Iceland32023,
        content2: Iceland42023,
        month: 'December'
      },
      {
        id: 3,
        duration: 4000,
        content1: Iceland52023,
        content2: Iceland62023,
        month: 'December'
      }
    ],
    description:
      'In a remote location in Iceland, we got warm and cozy under the Northern' +
      ' Lights to celebrate 2023 and get inspired for 2024.'
  },
  {
    id: 8,
    width: 300,
    year: 2024,
    isColumn: true,
    transform: { rotate: 2 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content1: Castle2024,
        content2: Castle22024,
        month: 'June'
      },
      {
        id: 2,
        duration: 4000,
        content1: Castle32024,
        content2: Castle42024,
        month: 'June'
      }
    ],
    description:
      'We stayed in a medieval German castle for our first Build Week in real life' +
      ', to make fast progress on important things.'
  },
  {
    id: 9,
    width: 300,
    year: 2024,
    isColumn: true,
    transform: { rotate: 3 },
    stories: [
      {
        id: 1,
        duration: 4000,
        content1: Vietnam22024,
        content2: Vietnam32024,
        month: 'November'
      },
      {
        id: 2,
        duration: 4000,
        content1: Vietnam42024,
        content2: Vietnam52024,

        month: 'November'
      }
    ],
    description:
      'We gathered in Hoi An, Vietnam, to celebrate the Year of Quality and steep' +
      ' ourselves in the culture of gifts, gratitude, and optimism.'
  }
];
